import {Box} from "@mui/system";
import React, {useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import styles from "../../../../../Vote/voteMainStyles";
import useModalSetup from "../../../../../../hooks/useModalSetup";
import CannotResolveModal from "../../../../../Vote/Sections/FooterSection/CannotResolve/CannotResolveModal";
import BasicSplitButton from "../../../../../../common/BasicSplitButton";
import useViewMessageDetails from "../../../Utilities/hooks/useViewMessageDetails";
import {getSupportedActions} from "../MessageAction/MessageActionEvaluatorUtils";
import {performAction} from "../MessageAction/MessageActionUtils";
import {ConstructiveFeedbackEntry} from "../Feedback/ConstructiveFeedback/ConstructiveFeedbackEntry";
import {PositiveFeedbackEntry} from "../Feedback/PositiveFeedback/PositiveFeedbackEntry";

export default function MessageActionMenu({ isScrollComplete }) {
    const {handleOpenModal, handleCloseModal, openModal} = useModalSetup();
    const {message} = useViewMessageDetails();
    const updatedIsReviewed = useSelector(state => state.messages.updatedIsReviewed);
    const options = getSupportedActions(message);
    const dispatch = useDispatch();
    const constructiveFeedbackRef = useRef();
    const positiveFeedbackRef = useRef();
    const params = {updatedIsReviewed, constructiveFeedbackRef, positiveFeedbackRef};

    const performMenuAction = (option) => {
        const actionType = _.get(option, 'id');
        performAction(dispatch, actionType, message, params);
    }

    return(
        <Box sx={{marginLeft: '10px'}}>
            <BasicSplitButton
                label={'Cannot resolve'}
                handleButtonAction={handleOpenModal}
                handleMenuAction={performMenuAction}
                options={options}
                disabled={!isScrollComplete}
                withIcon={false}
                sx={styles.cannotResolveButton}
            />

            <PositiveFeedbackEntry ref={positiveFeedbackRef} />
            <ConstructiveFeedbackEntry ref={constructiveFeedbackRef} />

            <CannotResolveModal
                title={'Cannot resolve'}
                open={openModal}
                handleClose={handleCloseModal}/>
        </Box>
    )
}